
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.606","height":"9.534"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_29957","data-name":"Group 29957","transform":"translate(.652 .6)"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"Group_29576","data-name":"Group 29576","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"d","d":"M9.4 1.762a1.285 1.285 0 010-.226A1.143 1.143 0 008.18.49H5.75v8.328h2","transform":"translate(-2.102 -.484)"}}),_c('path',{attrs:{"id":"e","d":"M2.132 8.815h2V.481H1.706A1.147 1.147 0 00.481 1.526a1.285 1.285 0 010 .226","transform":"translate(-.481 -.481)"}})])])])])])
          )
        }
      }
    